import $ from 'jquery';
// Import Swiper core and required modules instead of full bundle
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import WoocommerceProducts from './WoocommerceProducts';

/* ===============================================================
Product fast access js
=============================================================== */
class ProductFastAccess {
    constructor() {
        this.togglers = $('.irantheme-woocommerce-product-fast-access-toggle');
        this.main = $('.irantheme-product-fast-access');
        this.spinner = this.main.find('.irantheme-preloader-abs');
        this.wrapper = this.main.find('.irantheme-product-fast-access-wrapper');
        this.mask = this.main.find('.irantheme-mask-dark');
        this.events();
    }

    events() {
        $(document).on(
            'click',
            '.irantheme-woocommerce-product-fast-access-toggle',
            (e) => {
                // Get target click
                let target = $(e.target);

                // Check target tag name
                if ($(e.target).prop('tagName') == 'I') {
                    // Return to main parent toggle
                    target = $(target).parents(
                        '.irantheme-woocommerce-product-fast-access-toggle',
                    );
                }

                // Get product id
                let productId = $(target).data('product-id');

                // Fetch product
                this.getBoxAccess(productId);
            },
        );

        // Close product fast access
        this.wrapper.on(
            'click',
            '.irantheme-product-fast-access-close',
            (e) => {
                e.preventDefault();
                this.main.fadeOut();
            },
        );

        // Close main as soon as click on mask
        this.mask.on('click', () => {
            this.main.fadeOut();
        });
    }

    // Get product fast access
    getBoxAccess(productId) {
        // Get admin ajax url
        var ajax_url = iranthemeWpData.adminAjax;
        // Product fast access request =============================================
        $.ajax({
            url: ajax_url,
            type: 'post',
            data: {
                action: 'product_fast_access',
                product_id: productId,
            },
            dataType: 'html',
            beforeSend: (response) => {
                // Show wrapper
                this.wrapper.hide();
                // Hide spinner
                this.spinner.addClass('active');
                // Show product fast access
                this.main.fadeIn();
            },
            success: (response) => {
                // Append response to wrapper of fast access
                this.wrapper.html(response);
                // Add require swiper class to image or galleries
                this.wrapper
                    .find('.irantheme-product-gallery-images-hero')
                    .addClass('swiper irantheme-product-fast-access-slider');
                this.wrapper
                    .find('.irantheme-product-gallery-images-hero-wrapper')
                    .addClass('swiper-wrapper')
                    .after('<div class="swiper-pagination"></div>');
                this.wrapper
                    .find('.irantheme-product-gallery-images-hero-item')
                    .addClass('swiper-slide');
                this.wrapper
                    .find('.irantheme-zoomImg-container')
                    .addClass('no-zoom');
            },
            complete: (response) => {
                // Init slider
                this.initSlider();
                let woocommerceProducts = new WoocommerceProducts();
                setTimeout(() => {
                    // Show wrapper
                    this.wrapper.show();
                    // Hide spinner
                    this.spinner.removeClass('active');
                }, 1000);
            },
            error: (error) => {
                console.log(error.responseText);
            },
        });
    }

    // Init slider
    initSlider() {
        let fastAccessSlider = new Swiper(
            '.irantheme-product-fast-access-box .irantheme-product-fast-access-box-gallery-slider',
            {
                modules: [Navigation, Pagination],
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    // type: 'progressbar',
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            },
        );
    }
}

export default ProductFastAccess;
